import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthStateService } from './services/auth-state.service';

const authGuard = () => inject(AuthStateService).requireLogin(window.location.href);

const guestGuard = () => true;

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home.page').then(m => m.HomePage),
    canActivate: [guestGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'sign-in/verification-code',
    loadComponent: () => import('./components/verification-code.page').then(m => m.VerificationCodeComponent),
    canActivate: [guestGuard],
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy.page').then(m => m.PrivacyPage),
    canActivate: [guestGuard],
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms.page').then(m => m.TermsPage),
    canActivate: [guestGuard],
  },
  {
    path: 'my',
    loadComponent: () => import('./pages/main-layout.page').then(m => m.MainLayoutPage),
    canActivate: [authGuard],
    children: [
      { path: 'quotas', loadComponent: () => import('./pages/quota.page').then(m => m.QuotaPage) },
      { path: 'folders', redirectTo: 'quotas', pathMatch: 'full' },
      { path: 'folders/:folderId', loadComponent: () => import('./pages/folder').then(m => m.FolderComponent) },
      { path: 'profile', loadComponent: () => import('./pages/user-profile.component').then(m => m.UserProfileComponent) },
      { path: '', redirectTo: 'quotas', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
